import axios from 'axios';
const base = 'equipamiento';

function getAll(query = null) {
    return axios.get(base, { params: query });
}

function getHistory(idMac) {
    return axios.get(`${base}/history/${idMac}`);
}

function register(data) {
    return axios.post(base, data);
}

function update(data) {
    return axios.put([base, data?.id_eqt].join('/'), data);
}

const EquipamientoTkService = {
    getAll,
    getHistory,
    register,
    update
};
export default EquipamientoTkService;
